import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import AdminGuard from "./components/admin/AdminGuard";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminSecurity from "./pages/admin/AdminSecurity";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminCustomers from "./pages/admin/AdminCustomers";
import AdminProjects from "./pages/admin/AdminProjects";
import AdminOrders from "./pages/admin/AdminOrders";
import AdminLexware from "./pages/admin/AdminLexware";
import AdminTimesheetEdit from "./pages/admin/AdminTimesheetEdit";
import AdminAccountSecurity from "./pages/admin/AdminAccountSecurity";
import LnwPublic from "./pages/LnwPublic";
import ContactModalHost from "./components/ContactModalHost";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import Workbook from "./pages/Workbook";
import WorkbookDanke from "./pages/WorkbookDanke";
import Nis2 from "./pages/Nis2";
import Iec62443 from "./pages/Iec62443";
import Iec62443Goldstandard from "./pages/Iec62443Goldstandard";
import BacnetSc from "./pages/BacnetSc";
import OtAssetManagement from "./pages/OtAssetManagement";
import OtOrganisation from "./pages/OtOrganisation";
import OtNetworkArchitecture from "./pages/OtNetworkArchitecture";
import OtSecurityKrankenhaus from "./pages/OtSecurityKrankenhaus";
import Podcasts from "./pages/Podcasts";

const queryClient = new QueryClient();

const App = () => (
  <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <ScrollToTop />
          <ContactModalHost />
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/workbook" element={<Workbook />} />
            <Route path="/workbook/danke" element={<WorkbookDanke />} />
            <Route path="/nis2" element={<Nis2 />} />
            <Route path="/iec62443" element={<Iec62443 />} />
            <Route path="/iec62443-goldstandard" element={<Iec62443Goldstandard />} />
            <Route path="/bacnet-sc-migration" element={<BacnetSc />} />
          <Route path="/ot-asset-management" element={<OtAssetManagement />} />
          <Route path="/ot-organisation" element={<OtOrganisation />} />
          <Route path="/ot-netzwerkarchitektur" element={<OtNetworkArchitecture />} />
            <Route path="/ot-security-krankenhaus" element={<OtSecurityKrankenhaus />} />
            <Route path="/podcasts" element={<Podcasts />} />
            <Route path="/lnw/:token" element={<LnwPublic />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/sicherheit" element={<AdminSecurity />} />
            <Route path="/admin" element={<AdminGuard><AdminDashboard /></AdminGuard>} />
            <Route path="/admin/kunden" element={<AdminGuard><AdminCustomers /></AdminGuard>} />
            <Route path="/admin/projekte" element={<AdminGuard><AdminProjects /></AdminGuard>} />
            <Route path="/admin/auftraege" element={<AdminGuard><AdminOrders /></AdminGuard>} />
            <Route path="/admin/lexware" element={<AdminGuard><AdminLexware /></AdminGuard>} />
            <Route path="/admin/lnw/:id" element={<AdminGuard><AdminTimesheetEdit /></AdminGuard>} />
            <Route path="/admin/konto" element={<AdminGuard><AdminAccountSecurity /></AdminGuard>} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  </HelmetProvider>
);

export default App;
